<template>
    <div class="">
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        <div class="overflow-hidden position-relative" :style="{minHeight: `${wizardHeight}px`}">
            <div 
                id="wizard-shifter" 
                class="position-absolute d-flex gap-4" 
                style="width: 150%; transition: 0.4s all; top: 0;"
                :style="{left: mode === 'selection' ? 0 : '-50%'}"
            >
                <div class="d-flex flex-column" style="width: 33%;">
                    <div class="my-2 d-flex gap-4 align-items-end justify-content-between">
                        <div class="">
                            <h4 class="mb-1">Sourcing Events</h4>
                            <p class="text-muted small mb-0">Only showing Sourcing Events currently available for new invitations.</p>
                        </div>
                        <div class="">
                            <span class="text-muted small text-right">Select up to {{ maxSelectedRfx }} at once.</span>
                            <span v-if="maxxedOut" class="ml-3 font-size-80 font-weight-600 text-uppercase text-danger" style="transition: 0.2s all;">Limit Reached</span>
                        </div>
                    </div>
                    <div class="flex-fill border rounded bg-gray-200 overflow-auto" style="">
                        <div 
                            v-if="loadingInitial"
                            key="loadingInitial"
                            class="w-100 h-100 d-flex align-items-center justify-content-center"
                        >
                            <div class="text-gray-400 d-flex flex-column align-items-center">
                                <b-spinner class="mb-2"></b-spinner>
                                <div class="font-weight-bold font-size-90 ml-3 text-center">Loading sourcing events...</div>
                            </div>
                        </div>
                        <div v-else key="notLoadingList" class="">
                            <div v-if="Object.values(queryFilters).length" class="p-2 bg-gray-100">  <!-- FILTERS -->
                                <div class="d-flex justify-content-between align-items-start mb-2">
                                    <h6 class="mb-0 text-primary">Filters</h6>
                                    <b-button 
                                        size="sm"
                                        variant="gray-secondary"
                                        @click="getRfxs({resetFilters: true})"
                                    >Reset Filters</b-button>
                                </div>
                                <div class="d-flex flex-wrap align-items-end justify-content-between mb-1">  
                                    <div
                                        v-for="filter in Object.values(queryFilters)"
                                        :key="filter.key"
                                    >
                                        <b-form-group
                                            v-if="filter.filter_type == 'search'"
                                            :label="filter.label"
                                            label-class="font-size-70 text-uppercase font-weight-500 pb-1"
                                            class="mb-0"
                                        >
                                            <b-input-group
                                                class=""
                                            >
                                                <b-form-input
                                                    v-model="filter.value"
                                                    :id="'searchFilterInput-' + filter.key"
                                                    placeholder="Search..."
                                                    class="border-none"
                                                    :class="[filter.isSet ? 'bg-white' : 'bg-gray-100']"
                                                    :lazy="false"
                                                    @keydown.enter="getRfxs({resetPage: true})"
                                                ></b-form-input>
                                                <b-input-group-append>
                                                    <b-button 
                                                        :disabled="!filter.value" 
                                                        @click="getRfxs({resetFilters: true})"
                                                    >
                                                        <b-icon icon="x" class=""></b-icon>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                        <b-form-group
                                            v-if="filter.filter_type == 'select'"
                                            :label="filter.label"
                                            label-class="font-size-70 text-uppercase font-weight-500 pb-1"
                                            class="mb-0"
                                        >
                                            <b-form-select
                                                :options="filter.options"
                                                v-model="filter.value"
                                                value-field="value"
                                                text-field="label"
                                                class="border-none"
                                                :class="[filter.isSet ? 'bg-white' : 'bg-transparent']"
                                                @change="getRfxs({resetPage: true})"
                                            ></b-form-select>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                            <b-table
                                :items="rfxListForTable"
                                :fields="tableCols"
                                show-empty
                                empty-text="There are no Sourcing Events that match this criteria"
                                primary-key="id"
                                responsive
                                no-local-sorting
                                no-sort-reset
                                :sort-by.sync="sortByField"
                                :sort-desc.sync="sortDesc"
                                @sort-changed="getRfxs({resetPage: true})"
                                @input="resetHeight"
                                class="bg-white"
                                hover
                            >
                            <!-- class="possible-rfx-item d-flex px-3 py-1 border-bottom justify-content-between align-items-center"
                                :class="[(!rfx.selected && !rfx.canAdd) || rfx.invited ? 'not-possible' : '']"
                                style="min-height: 38px;" -->
                                <!-- <div class="rfx-title font-weight-bold">{{ rfx.title }}</div> -->
                                <template #cell(actions)="data">
                                    <span
                                        v-if="data.item.invited" 
                                        key="alreadyInvited" 
                                        class="font-weight-600 font-size-70 text-muted text-uppercase"
                                    >Already Invited</span>
                                    <b-button
                                        v-else-if="!data.item.selected && !data.item.canAdd" 
                                        key="notAllowed" 
                                        size="sm"
                                        variant="bare-secondary"
                                        :disabled="true"
                                    >Cannot be invited</b-button>
                                    <b-button 
                                        v-else-if="data.item.selected" 
                                        key="selected" 
                                        size="sm"
                                        variant="gray-primary"
                                        :disabled="!data.item.canRemove || loadingSave"
                                        @click="removeRfxId(data.item.id)"
                                    >
                                        <b-icon icon="dash-circle"></b-icon>
                                        Remove
                                    </b-button>
                                    <b-button
                                        v-else 
                                        key="notSelected" 
                                        size="sm"
                                        variant="light-primary"
                                        :disabled="!data.item.canAdd || loadingSave"
                                        @click="addRfxId(data.item.id)"
                                    >
                                        <b-icon icon="plus-circle"></b-icon>
                                        Add
                                    </b-button>
                                </template>
                            </b-table>
                            <div v-if="!loadingInitial && totalRows" class="px-2 pb-2">
                                <base-table-pagination
                                    :current-page.sync="currentPage"
                                    :per-page.sync="perPage"
                                    :total-items="totalRows"
                                    :show-per-page="false"
                                    item-name="Sourcing Events"
                                    @update:perPage="getRfxs({resetPage: true})"
                                    @update:currentPage="getRfxs"
                                ></base-table-pagination>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column" style="width: 33%;">
                    <div class="my-2 d-flex gap-4">
                        <h4 class="mb-0">Selected Sourcing Events</h4>
                        <div class="">
                            <span>{{ selectedRfxIds.length }} selected</span>
                            <span v-if="maxxedOut" class="ml-3 font-size-80 font-weight-600 text-uppercase text-danger" style="transition: 0.2s all;">Limit Reached</span>
                        </div>
                    </div>
                    <div class="flex-fill p-1 border rounded bg-gray-200 overflow-auto d-flex flex-column gap-1" style="">
                        <div 
                            v-if="selectedRfxObjects.length < 1"
                            class="w-100 h-100 d-flex align-items-center justify-content-center"
                        >
                            <div class="text-gray-400 d-flex align-items-center">
                                <b-icon icon="arrow-left" font-scale="2"></b-icon>
                                <div class="font-weight-bold font-size-120 ml-3 text-center">Select sourcing events<br>from the list</div>
                            </div>
                        </div>
                        <div 
                            v-for="rfx in selectedRfxObjects"
                            :key="rfx.id"
                            class="border rounded bg-white px-3 py-2 d-flex align-items-center justify-content-between"
                        >
                            <div class="font-weight-bold">{{ rfx.title }}</div>
                            <div>
                                <b-button 
                                    size="sm"
                                    variant="gray-primary"
                                    :disabled="loadingSave"
                                    @click="removeRfxId(rfx.id)"
                                >
                                    <b-icon icon="dash-circle"></b-icon>
                                    Remove
                                </b-button>
                            </div>
                        </div>
                        <!-- <div v-if="selectedVendors.length" class="my-1 text-muted small text-center">
                            Click on a contact's name to add/remove them from the invitation.
                        </div> -->
                    </div>
                </div>
                <div class="d-flex flex-column" style="width: 33%;">
                    <div class="my-2 d-flex gap-4">
                        <h4 class="mb-0">Message</h4>
                    </div>
                    <div class="flex-fill p-2 border rounded bg-gray-200 overflow-auto" style="">
                        <p class="text-muted small mb-4">
                            A single email will be sent to the selected contacts notifying them of <span class="font-italic">all</span> selected Sourcing Events.
                        </p>
                        <!-- <b-form-group
                            id="fieldset-invite-message"
                            label="Message to Supplier"
                            label-for="textarea-invite-message"
                            label-class="h6"
                        >
                            <template #label>
                                <ul class="small text-muted list-flush">
                                    <li>A single email will be sent to the selected contacts at this company notifying them of all selected Sourcing Events.</li>
                                    <li>Adding an additional message (below) is optional.  If included, it will be included at the top of the normal invitation email.</li>
                                </ul>
                            </template>
                            <b-form-textarea 
                                id="textarea-invite-message" 
                                v-model="invitationNote" 
                                trim
                                rows="10"
                                placeholder="Write a message to this vendor (optional)"
                            ></b-form-textarea>
                        </b-form-group> -->
                        <FormulateForm
                            :schema="inviteFormSchema"
                            v-model="inviteFormData"
                            :name="inviteFormName"
                            @submit="handleInviteFormSubmit"
                        ></FormulateForm>
                        <!-- <div v-if="!canSendInvites" class="my-2 font-size-90">
                            <span class="font-weight-bold">NOTE:</span> Invitations will be queued and sent when the Event is OPEN.
                        </div> -->
                        <div class="py-2 d-flex align-items-center justify-content-between">
                            <div class="font-size-80">
                                <!-- You are inviting this vendor to <span class="font-weight-bold">{{ selectedRfxIds.length }} sourcing event<span v-if="selectedRfxIds.length > 1">s</span></span>. -->
                                <span v-if="!hasContactsToSend" class="font-weight-bold font-size-80">You must add contacts for this company</span>
                            </div>
                            <b-button variant="success" size="lg" :disabled="!canSend || loadingSave" @click="startInviteFormSubmit" class="min-width-200">
                                <b-spinner v-if="loadingSave" small class="mr-1"></b-spinner>
                                {{ loadingSave ? 'Sending...' : 'Send Invitation' }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="my-2 w-100 d-flex justify-content-between align-items-center">
            <div class="">
                <b-button :disabled="loadingSave || (mode !== 'message')" size="lg" variant="primary" @click="mode = 'selection'">&larr; Previous</b-button>
            </div>
            <div class="d-flex align-items-center gap-4">
                <b-button size="lg" variant="light-secondary" @click="$emit('cancel')">Cancel</b-button>
                <b-button :disabled="(mode !== 'selection') || !hasSelectedRfx || loadingSave" size="lg" variant="primary" @click="mode = 'message'">Next &rarr;</b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { errorHandling } from '../../js/custom-vue-mixins';
import { suppliosApi } from '../../js/api-service.js';
import cloneDeep from 'lodash/cloneDeep';
import { FormatDateHelper } from '../../js/filters-helpers.js';
import BaseTablePagination from '../BaseTablePagination.vue';
import debounce from 'lodash/debounce';

// this is for inviting a SINGLE COMPANY to many RFX's at once

// LIST FILTER CLASS -- move to generic location later if this works well
class ListQueryFilter {
    constructor({  // you can set defaults for constructor params here, or just let them be undefined and set in constructor method
        key,  // we use this as the key in 'query_params' AND for identifying this filter amongst others in the Vue component
        label,
        filter_type, // boolean, select, multiselect, search?
        options,  // array of objects, { value(string), label(string) } - should still use them for boolean, so you set user-friendly labels for true/false, and can be explicit about allowing neither true/false (unset)
        default_value,  // default value -- either '' for search, true/false literal for boolean, or default 'value' for select/multiselect
        value,  // the CURRENT VALUE - only set this if we want it to be pre-set to something specific, otherwise we will set to default_value
        // TODO - add existing_values array? -- pass in array of existing values on the list items you fetched, and only show options that actually exist in the list?  only works if you have complete list, not paginated (or you get full list from server side)
    }) {
        this.label = label;
        this.key = key;
        this.filter_type = filter_type;
        this.options = options;  // won't have any for some filter_type - but should be a list of objects otherwise { value, label }
        const noOptionsTypes = ['search'];  // add more later if needed...
        const optionsRequiredTypes = ['select', 'multiselect'];
        if (this.options == undefined) {
            if (noOptionsTypes.includes(this.filter_type)) {
                this.options = [];  // set to empty array just to keep types nice
            } else if (this.filter_type == 'boolean') {
                this.options = [  // these are only the defaults... you can pass them explicitly for boolean filters
                    { value: null, label: 'Not Set' },
                    { value: true, label: 'Yes' },
                    { value: false, label: 'No' },  
                ];
            } else if (optionsRequiredTypes.includes(this.filter_type)) {
                console.error(`For filter of key ${this.key} - you must provide options array, but you did not`);
                this.options = [];
            }
        }
        this.default_value = default_value;
        if (this.default_value === undefined) {
            // if we didn't pass in a default value, set one depending on the filter_type
            if (this.filter_type == 'search') {
                this.default_value = '';
            } else if (this.filter_type == 'boolean') {
                this.default_value = false;
            } else if (this.filter_type == 'select') {
                this.default_value = '';
            } else if (this.filter_type == 'multiselect') {
                this.default_value = [];
            }
        }
        // store what we consider 'unset' values - based on the filter_type
        this.unset_values = ['', null, undefined, []];  // should work for all filter_type for now.... 
        // SET THE CURRENT VALUE 
        this.value = value ?? this.default_value;
        this.initial_value = Array.isArray(this.value) ? [...this.value] : this.value;  // make shallow copy if its an array so we don't mutate it
    }
    // GETTERS (experimental)
    get isSet() {
        return !this.isUnset();
    }
    // METHODS
    isUnset() {
        // is this filter set?  if not, then we don't output anything in getParams (just empty object)
        // return boolean 
        return this.unset_values.includes(this.value);
    }
    getParams() {
        // return an OBJECT with the query params -- will merge these from all filters, then use to instantiate URLSearchParams(paramsObj) or pass to axiosConfig.params
        const paramsObj = {};
        if (this.isUnset()) {
            return paramsObj;
        }
        paramsObj[this.key] = this.value;
        return paramsObj;
    }
    reset() {
        // reset to the INITIAL value we passed in (may be default if we didn't explicitly set a value)
        this.value = Array.isArray(this.initial_value) ? [...this.initial_value] : this.initial_value;
    }
}

export default {
    name: 'CompanyBulkInviteRfx',
    components: {
        BaseTablePagination,
    },
    mixins: [
        errorHandling,
    ],
    props: {
        companyId: {
            type: String,
            required: true,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            mode: 'selection',  // options are 'selection' and 'message'
            loadingList: false,
            loadingSave: false,
            loadingExisting: false,
            loadingFilters: false,
            availableRfxList: [],  // get from API
            availableRfxMap: {},  // from list, keyed by ID
            existingResponses: [],  // get from API
            invitationNote: '', 
            // FROM OTHER COMP
            selectedRfxIds: [],  
            selectedRfxMap: {},  // we stash the full RFX object here, keyed by ID, so we can use pagination/search/filters on RFX list
            selectedTuIds: [],
            maxSelectedRfx: 50,  // limit to 50 for now until you know what performance is like on backend
            tableFields: [
                {
                    key: 'name', 
                    label: 'Sourcing Event',
                    class: 'width-200',
                },
                {
                    key: 'actions', 
                    label: 'Actions',
                    class: 'text-center',
                },
            ],
            queryFilters: {},  // ListQueryFilter objects, keyed by their 'key' 
            filterDefs: [],  // moved to API method to get things dynamically
            sortByField: 'created',
            sortDesc: true,
            currentPage: 1,
            perPage: 10,
            totalRows: null,  // get from API paginated response
            tableCols: [
                {
                    key: 'title',
                    label: 'Event Title',
                    sortable: true,
                    api_ordering_name: 'title',
                    tdClass: 'font-weight-bold',
                },
                {
                    key: 'created',
                    label: 'Created On',
                    sortable: true,
                    api_ordering_name: 'created',
                    tdClass: '',
                    formatter: (value) => {
                        return value ? FormatDateHelper(value) : '';
                    },
                },
                {
                    key: 'actions',
                    label: 'Actions',
                    class: 'text-center',
                    sortable: false,
                },
            ],
            wizardHeight: 500,  // updates using getWizardShifterHeight() after we load things
            // final invite form
            inviteFormName: 'inviteForm',
            inviteFormSchema: [
                {
                    type: 'snippet_textarea',
                    snippetArea: 'rfx_invite_email',
                    label: 'Invitation Message',
                    name: 'invitation_note',  // must match backend view 
                    rows: 10,
                    placeholder: "(Optional) custom message to this vendor",
                    help: 'Write an optional custom message to this vendor.  It will be added before the standard text of the invitation email.',
                    helpPosition: 'before',
                    class: "mb-4",
                },
                {
                    type: 'vendorcontactpicker',
                    name: 'contact_ids',  // must match backend view 
                    label: 'Company Contacts to Invite:',
                    validation: ['required'],
                    validationName: 'Company Contacts',
                    vendorId: this.companyId,
                    selectDefaults: 'ext_sourcing',  // TenantRole slug
                    showDefaults: false,  // makes things too long if true
                    noAdd: false,
                    help: 'Select the contacts at this company who should be notified of this sourcing event and have access to respond.',
                    helpPosition: 'before',
                },
            ],
            inviteFormData: {},  // v-model to the FormulateForm
        }
    },
    computed: {
        loadingInitial() {
            return this.loadingList || this.loadingExisting || this.loadingFilters;
        },
        maxxedOut() {
            return this.selectedRfxIds.length >= this.maxSelectedRfx;
        },
        alreadyInvitedRfxIds() {
            return this.existingResponses.map(respObj => respObj.rfx_id);
        },
        rfxListForTable() {
            // for displaying in the table/list
            const maxxedOut = this.selectedRfxIds.length >= this.maxSelectedRfx;
            return Object.values(this.availableRfxMap).map(rfxObj => {
                const isLocalSelected = this.selectedRfxIds.includes(rfxObj.id);
                const isAlreadyInvited = this.alreadyInvitedRfxIds.includes(rfxObj.id);
                return {
                    ...rfxObj,
                    selected: isLocalSelected,
                    invited: isAlreadyInvited,  // already invited before this bulk invite
                    canAdd: !maxxedOut, // maxxedOut ? false : !rfxObj.disabled,
                    canRemove: isLocalSelected,
                    //noContacts: vObj.tus.length < 1,
                };
            });
        },
        selectedRfxObjects() {
            // returns an ARRAY of OBJECTS of the selected new rfx objects for invite
            return Object.values(this.selectedRfxMap);  // this.selectedRfxIds.map(rfxId => this.availableRfxMap[rfxId]);
        },
        wizardShifterStyle() {
            return this.mode === 'selection' ? {left: 0} : {right: 0};
        },
        hasSelectedRfx() {
            return this.selectedRfxIds.length > 0;
        },
        hasContactsToSend() {
            const contactIds = this.inviteFormData?.contact_ids || [];
            return !!contactIds.length;
        },
        canSend() {
            return this.hasSelectedRfx && this.hasContactsToSend;
        },
    },
    watch: {
        loadingInitial: 'resetHeight',
        inviteFormData: {  // need this so if we add contacts, things resize
            deep: true,
            handler: 'resetHeight',
        }
    },
    created() {
    },
    mounted: function() {
        this.getRfxs({resetPage: true, resetFilters: true});
        this.getResponses();
        this.getFilters();  // for getting values of things in filters... can replace later when you have filter schema
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        async getFilters() {
            this.loadingFilters = true;
            try {
                const resp = await suppliosApi.rfx.getRfxSetupOptions();
                const categoryOptions = resp.data.sourcing_category_options ?? [];  // they have { value, text }
                const preppedCategoryOptions = categoryOptions.map(opt => {
                    return {
                        value: opt.value,
                        label: opt.text,
                    }
                });
                const rfxTypeOptions = resp.data.rfx_type_options ?? [];  // will be short names, with { value, text}
                const preppedRfxTypeOptions = rfxTypeOptions.map(opt => {  // remap to { value, label } for consistency with others
                    return {
                        value: opt.value,
                        label: opt.text,
                    }
                });
                const filterDefs = [
                    {
                        label: 'Search',
                        key: 'search',
                        filter_type: 'search',
                    },
                    {
                        label: 'Event Type',
                        key: 'rfx_type',
                        filter_type: 'select',
                        default_value: '',
                        options: [
                            {value: '', label: 'All Types'},
                            ...preppedRfxTypeOptions,
                        ],
                    },
                ];
                if (preppedCategoryOptions.length) {
                    filterDefs.push({
                        label: 'Category',
                        key: 'sourcing_category',
                        filter_type: 'select',
                        default_value: '',
                        options: [
                            {value: '', label: 'All Categories'},
                            ...preppedCategoryOptions,
                        ]
                    });
                }
                this.filterDefs = filterDefs;
            } catch (err) {
                this.apiErrorHandler(err);
            }
            // now set queryFilters
            const queryFilters = this.filterDefs.map(fDef => new ListQueryFilter(fDef));
            this.queryFilters = Object.fromEntries(queryFilters.map(qf => ([qf.key, qf])));
            this.loadingFilters = false;
        },
        resetFilters(filterKeys) {
            // reset the filters - filterKeys can be a single string filter key, or array of them, or null (clear all)
            // this DOES NOT refresh the list -- call then when refreshing the list if resetFilters = true
            console.log(`From resetFilters - we passed these filterKeys: ${filterKeys}`);
            let keysToReset = [];
            if (Array.isArray(filterKeys)) {
                keysToReset.push(...filterKeys);
            } else if (typeof filterKeys == 'string') {  // gotta make sure its a string
                keysToReset.push(filterKeys);  // must just be one if here
            } else {
                // if not a single string, not an array, then its the other args of the event... just reset all
                const allFilterKeys = Object.keys(this.queryFilters);
                keysToReset.push(...allFilterKeys);
            }
            keysToReset.forEach(key => {
                this.queryFilters[key].reset();
            });
        },
        getOrderingFieldString: function() {
            // look up what field name (string) we should use to send to API, in case key here is different than what API should order by
            // useful if you have serializer methods that get values from related objects... you can use double-underscore notation in DRF for ordering
            // also add '-' if sortDesc is true
            let apiOrderingName = this.tableCols.find(fld => fld.key === this.sortByField).api_ordering_name;
            return (this.sortDesc ? '-' : '') + apiOrderingName;
        },
        getQueryParams() {
            // build the query based on applied filters, sorting, pagination, etc.
            const filterObjects = Object.values(this.queryFilters);
            let filterParams = {};
            filterObjects.forEach(fil => {
                const params = fil.getParams();  // plain object, just with params for this filter
                Object.assign(filterParams, params);
            });
            // TODO - add sorting, if you have that later
            let orderingParams = {
                ordering: this.getOrderingFieldString(),
            };
            let paginationParams = {
                page: this.currentPage,
                page_size: this.perPage,
            };
            return Object.assign({}, filterParams, orderingParams, paginationParams);
        },
        async getRfxs({resetPage = false, resetFilters = false}) {
            // get a list of the RFXes that are open for invites
            this.loadingList = true;
            console.log(`resetPage = ${resetPage} - resetFilters = ${resetFilters}`);
            if (resetPage || resetFilters) {
                // if resetFilters, we also must reset page
                this.currentPage = 1;
            }
            if (resetFilters) {
                this.resetFilters();
            }
            const axiosConfig = {
                params: this.getQueryParams(),
            };
            try {
                const resp = await suppliosApi.rfx.list_available_for_invites(axiosConfig);
                this.availableRfxList = resp.data.results;  // paginated!
                this.totalRows = resp.data.count;
                // ... actually, maybe just use normal list endpoint with extra filter added for 'can_create_invites'
                this.availableRfxMap = Object.fromEntries(this.availableRfxList.map(rfxObj => ([rfxObj.id, rfxObj])));
            } catch (err) {
                this.apiErrorHandler(err);
            }
            this.loadingList = false;
            this.resetHeight();
        },
        async getResponses() {
            // get list of Rfx/RfxResponse for this company, already invited to
            this.loadingExisting = true;
            try {
                const resp = await suppliosApi.rfxResponse.list_for_company(this.companyId);
                this.existingResponses = resp.data;  // not paginated.. for now at least
            } catch (err) {
                this.apiErrorHandler(err);
            }
            this.loadingExisting = false;
            this.resetHeight();
        },
        ///////////////////
        addRfxId(rfxId) {
            // add a Rfx to selected
            const rfxObj = this.availableRfxMap[rfxId];
            this.selectedRfxIds.push(rfxId);
            this.$set(this.selectedRfxMap, rfxId, cloneDeep(rfxObj));
            // const defaultSourcingContactIds = vendorObj.tus.filter(tu => (tu.tenant_roles || []).some(role => role.slug === 'ext_sourcing')).map(tu => tu.id);
        },
        removeRfxId(rfxId) {
            // remove a Rfx from the selected list
            this.selectedRfxIds = this.selectedRfxIds.filter(id => rfxId !== id);
            // can't just delete a property from the selectedRfxMap -- not reactive - so make a new object instead
            // but keep in mind, due to pagination, you don't have a full list of all RFX objects.... so have to deal with the existing selectedRfxMap
            this.selectedRfxMap = Object.fromEntries(Object.values(this.selectedRfxMap).filter(rfxObj => (this.selectedRfxIds.includes(rfxObj.id))).map(rfxObj => ([rfxObj.id, rfxObj])));
        },
        getDataForApi() {
            return {
                invitation_note: this.invitationNote,
                rfxIds: [...this.selectedRfxIds],
            };
        },
        done() {
            // tell parent we're done so it can close whatever we are in, if needed
            this.$emit('done');
        },
        resetHeight() {
            // create debounced function if not already set, then call it
            if (!this.debouncedResetHeight) {
                this.debouncedResetHeight = debounce(this.performResetHeight, 200);
            }
            this.debouncedResetHeight();
        },
        performResetHeight() {
            const minHeight = 500;
            const currentHeight = this.wizardHeight || minHeight;  // we will only grow, not shrink
            this.$nextTick(() => {
                const newHeight = Math.max(this.getWizardShifterHeight(), currentHeight, minHeight);
                if (newHeight != this.wizardHeight) {
                    this.wizardHeight = newHeight;
                    console.log('resetting height to', this.wizardHeight);
                }
            });
        },
        getWizardShifterHeight() {
            const wizardShifter = document.getElementById('wizard-shifter');
            return wizardShifter ? wizardShifter.getBoundingClientRect().height : 0;
        },
        startInviteFormSubmit() {
            // programmatically call submit on the inviteForm (uses vue-formulate named form method)
            // then get the data from the handler for @submit event
            this.$formulate.submit(this.inviteFormName);
        },
        async handleInviteFormSubmit(formData) {
            // from @submit event of the form -- only called when everything in that form is valid
            // this should by async
            // need to combine with the list of rfxIds 
            const rfx_ids = [ ...this.selectedRfxIds];
            if (rfx_ids.length < 1) {
                this.$toast('Must select at least one Sourcing Event.');
                return;
            }
            const inviteData = { ...formData, rfx_ids, company_id: this.companyId };
            console.log('inviteData', inviteData);
            this.loadingSave = true;
            try {
                const resp = await suppliosApi.rfx.company_bulk_invite_rfx(inviteData);
                const newRespList = resp.data;  // list/array with very basic things about the new responses (not full serializer)
                const newRespCount = newRespList.length;
                //const msg = this.canSendInvites ? `Invited ${newRespCount} new vendors` : `Created ${newRespCount} new invites, queued for sending`;
                const msg = `Invited this supplier to ${newRespCount} new sourcing events.`;
                console.log(newRespList);
                this.$toast.success(msg);
                this.$emit('invites-sent');  // no payload for now
                this.done();
            } catch (err) {
                this.apiErrorHandler(err);
            }
            this.loadingSave = false;
        }
    }
}
</script>

<style lang="scss">

.possible-rfx-item {
    background-color: #fff;
    .rfx-title {
        color: $dark;
    }

    &.not-possible {
        background-color: $gray-100;
        .rfx-title {
            color: $gray-500;
        }

    }
}

</style>